import { createReducer, Reducer } from "@reduxjs/toolkit";
import { NotificationActions } from "./actions";
import { Notification } from "./models";

// Reducer
export const notificationReducer: Reducer<
  Notification,
  NotificationActions.Actions
> = createReducer<Notification>(null, (builder) => {
  builder
    .addCase(NotificationActions.setNotification, (_, action) => {
      return action.payload;
    })
    .addCase(NotificationActions.clearNotification, () => {
      return null;
    });
});
